module.exports = __webpack_public_path__ + "static/media/piles-of-casks.4544dde7.png";